// Alternate viewer component for unsupported file types
type AltViewerProps = {
    fileUrl?: string;
    fileName: string;
};

const AltViewer: React.FC<AltViewerProps> = ({ fileUrl = "", fileName }) => (
    <div className="d-flex flex-column align-items-center justify-content-center p-4 h-100">
        <div className="text-center mb-4">
            <i className="bi bi-file-x text-muted" style={{ fontSize: '4rem' }}></i>
            <h5 className="mt-3 mb-2">File Preview Not Available</h5>
            <p className="text-muted">
                This type of file cannot be previewed in the browser.<br />
                Please download it to view its contents.
            </p>
        </div>
        {fileUrl && (
            <div className="text-center">
                <a
                    href={fileUrl}
                    download={fileName}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <i className="bi bi-file-earmark-arrow-down me-1"></i>
                    {fileName}
                </a>
            </div>
        )}
    </div>
);

export default AltViewer;